import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import FieldSetToggleButton_module from "./FieldSetToggleButton.module.js";
import FieldSet_module from "./FieldSet.module.js";
import { Button } from "../../../button/Button.js";
import { IconChevron } from "../../../../icons/IconChevron.js";
import { IconDanger } from "../../../../icons/IconDanger.js";
import { Cluster } from "../../../cluster/Cluster.js";
import { combineClasses } from "../../../../utilities/combineClasses.js";
const FieldSetToggleButton = /*#__PURE__*/ forwardRef(({ expanded, showDangerIcon, className, children, ...props }, ref)=>/*#__PURE__*/ jsx(Button, {
        variant: "ghost",
        className: combineClasses(FieldSetToggleButton_module.toggleButton, FieldSet_module.fieldSetLabelTypography, className),
        ...props,
        ref: ref,
        children: /*#__PURE__*/ jsxs(Cluster, {
            gap: "100",
            children: [
                /*#__PURE__*/ jsx(IconChevron, {
                    className: FieldSetToggleButton_module.icon,
                    rotation: expanded ? void 0 : 270,
                    color: "gray-800"
                }),
                /*#__PURE__*/ jsx("div", {
                    className: FieldSetToggleButton_module.label,
                    children: children
                }),
                showDangerIcon && /*#__PURE__*/ jsx(IconDanger, {
                    className: FieldSetToggleButton_module.icon,
                    color: "danger-600"
                })
            ]
        })
    }));
FieldSetToggleButton.displayName = 'FieldSetToggleButton';
export { FieldSetToggleButton };
